export default __webpack_public_path__ + "static/media/contact.750897e9.webp";